/**
 * Default email HTML templates for ActivityType admin form (frontend mirror).
 * Keep in sync with backend/src/utils/defaultEmailTemplates.js
 */

export const DEFAULT_CONFIRMATION_EMAIL_HTML = `
<div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
  <p>Bonjour {{userName}},</p>
  <p>Merci pour votre inscription. Voici les détails de votre activité :</p>
  <p>
    <strong>Activité :</strong> {{activityTitle}}<br>
    <strong>Catégorie :</strong> {{categoryName}}<br>
    <strong>Date :</strong> {{date}}<br>
    <strong>Heure :</strong> {{time}}<br>
    <strong>Durée :</strong> {{duration}} minutes<br>
    <strong>Lieu :</strong> {{location}}<br>
    <strong>Nombre de participants :</strong> {{numberOfParticipants}}
  </p>
  <p>À bientôt !</p>
  <p>La Yoga Yourte du Luberon</p>
</div>
`.trim();

export const DEFAULT_CANCELLATION_EMAIL_HTML = `
<div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
  <p>Bonjour {{userName}},</p>
  <p>Nous confirmons l'annulation de votre inscription pour l'activité suivante :</p>
  <p>
    <strong>Activité :</strong> {{activityTitle}}<br>
    <strong>Catégorie :</strong> {{categoryName}}<br>
    <strong>Date :</strong> {{date}}<br>
    <strong>Heure :</strong> {{time}}<br>
    <strong>Lieu :</strong> {{location}}
  </p>
  <p>Si vous avez des questions, n'hésitez pas à nous contacter.</p>
  <p>La Yoga Yourte du Luberon</p>
</div>
`.trim();

export const DEFAULT_PREPARATION_HTML = `
<div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
  <h3>Préparation</h3>
  <p>Merci de lire attentivement le mail de confirmation pour venir dans la tenue adaptée et bien vous préparer pour la séance.</p>
</div>
`.trim();
